import z from 'zod';
import { caseIdValue } from '../../case/value-objects/ids';
export const USER_CALENDAR_EVENT_STATUSES = [
    'cancelled',
    'confirmed',
];
export const userCalendarEventStatusValue = z.enum(USER_CALENDAR_EVENT_STATUSES);
export const userCalendarEventSchema = z.object({
    caseId: caseIdValue,
    date: z.date(),
    description: z.string().min(1).optional(),
    status: userCalendarEventStatusValue,
    stepId: z.string().min(1),
    summary: z.string().min(1),
});
export const parseUserCalendarEvent = (value) => userCalendarEventSchema.parse(value);
export const isUserCalendarEvent = (value) => userCalendarEventSchema.safeParse(value).success;
//# sourceMappingURL=user-calendar-event.js.map